var events = {
  planChange: function(company, tariff) {
    return { event: 'ecomEvent', 'ecommerce': {
      'purchase': {
        'actionField': {
          'id': company.id, // Transaction ID. Required for purchases and refunds.
          'revenue': parseFloat(tariff.price) || tariff.price // Total transaction value per month
        },
        'products': [{ // List of productFieldObjects.
          'name': tariff.name, // Name of our plan (e.g. 1-500-14.99-0 for starter package)
          'id': tariff.id, // plan unique value
          'price': parseFloat(tariff.price) || tariff.price, // plan price
          'quantity': 1
        }]
      }
    }};
  },
  // LOGGED_IN: 'GA-event-user-logged-in-from-login',
  LOGGED_IN: 'GA-event-user-logged-in-from-login',

  ACC_VERIFICATION_INVALID_NUMBER: {event: 'onboarding-sms-trip', value: 1},
  ACC_VERIFICATION_SMS_SENT: {event: 'onboarding-sms-sent', value: 1},
  ACC_VERIFICATION_WRONG_CODE: {event: 'onboarding-sms-verify-wrong', value: 1},
  ACC_VERIFICATION_VERIFIED: {event: 'onboarding-sms-verified', value: 1},
  NUMBER_SEARCH: {event: 'onboarding-searched-numbers', value: 1},
  NUMBER_CHOSE: {event: 'onboarding-chose-number', value: 1},
  FIRST_CALL: {event: 'onboarding-first-call-received', value: 1},
  SCREENSHARE_SHARER: {event: 'shared-screen-sharer', value: 1},
  SCREENSHARE_VIEWER: {event: 'share-screen-viewer', value: 1},
  AUTH_LOGIN: {event: 'user', value: 1},
  AUTH_LOGOUT_BEFORE_NUMBER: {event: 'logged-out-before', value: 1},
};

/**
 * Google tag manager - dataLayer push
 */
angular.module('bbl.services.gtm', [])

  .factory('gtmJS', ['$window', function($window) {
    var ifr = document.createElement('iframe');
    ifr.src = 'https://brandedbridgeline.com/event_sender.html';
    Object.assign(ifr.style, { display: 'none' });
    document.body.appendChild(ifr);

    function pushEvent(message) {
      ifr.contentWindow.postMessage(message, 'https://brandedbridgeline.com');
    }

    return {
      events: Object.keys(events).reduce(function(p, c) { return (p[c] = c, p); }, {}),
      push: function(eventName) {
        var handler = events[eventName];

        var data = typeof handler === 'function' ?
          events[eventName].apply(null, [].slice.call(arguments, 1)) :
          events[eventName];

        pushEvent(JSON.stringify({data: data, type: 'dl.push'}));
        // $window.dataLayer.push(data);
      }
    };
  }]);



/*****************
 ** WEBPACK FOOTER
 ** ./app/common/gtm.js
 ** module id = 237
 ** module chunks = 0
 **/